import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

import { Box, Menu, MenuButton, MenuItem, MenuList, useToken, Icon } from 'quotient';

import { NavigationMenuItem } from './types';

export type NavigationItemMenuProps = {
  itemId: string;
  menuItems: NavigationMenuItem[];
  icon: IconDefinition;
};

// Providing extra space to make clickable area larger
// We aren't doing this vertically because it causes the navbar to resize on hover
const horizontalButtonPadding = 2;

export const NavigationItemMenu: React.FC<NavigationItemMenuProps> = ({ itemId, menuItems, icon }) => {
  const [normalTextColor] = useToken('colors', ['primaryNeutral.900']);

  const handleMenuItemClick = (menuItem: NavigationMenuItem) => {
    menuItem.onClick(itemId);
  };

  const handleMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the navigation item click
  };

  return (
    <Menu>
      <MenuButton
        _hover={{ bg: 'primaryNeutral.200' }}
        as={Box}
        bg="transparent"
        border="none"
        borderRadius="md"
        cursor="pointer"
        px={horizontalButtonPadding}
        onClick={handleMenuClick}
      >
        <Icon color={normalTextColor} icon={icon} size="sm" />
      </MenuButton>
      <MenuList border="none">
        {menuItems.map((menuItem) => (
          <MenuItem
            color={menuItem.color || normalTextColor}
            icon={<Icon icon={menuItem.icon} />}
            key={menuItem.id}
            onClick={() => handleMenuItemClick(menuItem)}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
